import styled from "styled-components"

export const Button = styled.button`
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  outline: none;
  border-radius: 0.7rem;
  font-weight: 500;
  white-space: nowrap;
  padding: 1.1rem 1.2rem;
  font-size: 1.5rem;
  ${(props) => props.css};
`
export const PrimaryButton = styled(Button)`
  color: ${(props) =>
    props.disabled
      ? props.theme.colors.webinar.button.disabledText
      : props.theme.colors.webinar.button.primaryText};
  background-color: ${(props) =>
    props.disabled
      ? props.theme.colors.webinar.button.disabled
      : props.theme.colors.webinar.button.primary};

  &:hover {
    background-color: ${(props) =>
      props.disabled
        ? props.theme.colors.webinar.button.disabled
        : props.theme.colors.webinar.button.primaryHover};
  }
`
export const SecondaryButton = styled(Button)`
  color: "#222222";
  background: "white";
  border: "1px solid #222222";
  &:hover {
    background-color: ${(props) =>
      props.disabled ? props.theme.colors.webinar.button.disabled : "#f2f2f2"};
  }
`
